import { FaPhoneAlt, FaCheck } from "react-icons/fa";
import "./DemoSection.css";
import logo from "../assets/blured.png";
import demo from "../assets/demo.png";

/**
 * Open the CloudCall / Voicy conversation panel
 */
const openCloudCallWidget = () => {
  const agent = document.querySelector("voicy-agent");

  if (!agent) {
    console.warn("CloudCall widget has not loaded yet.");
    return;
  }

  if (typeof agent.openPanel === "function") {
    agent.openPanel();
    return;
  }

  console.warn("CloudCall openPanel() method is not available.");
};

export default function DemoSection() {
  return (
    <section className="demo">
      <div className="container demo-grid">

        {/* LEFT: visual / interactive panel */}
        <div className="demo-visual">
          <div className="demo-banner">
            <span>Live Demo · Available 24/7</span>
          </div>

          <img
            src={demo}
            alt="CloudCall Live Demo"
          />
        </div>

        {/* RIGHT: content */}
        <div className="demo-content">

          <h2>
            Experience Our AI-Powered Contact Center
          </h2>

          <p>
            Step into a real customer experience and get a feel for
            our AI-powered contact center. Roleplay as a customer
            requesting a <strong>motor insurance quote</strong> and
            experience the journey from start to finish.
          </p>

          <p>
            When prompted for your customer ID, use the passcode{" "}
            <strong>1234</strong>. Explore the sandbox and see how the
            AI handles questions, objections, and follow-ups.
          </p>

          <ul className="demo-checklist">

            <li>
              <span className="check-icon">
                <FaCheck />
              </span>
              Available through both live chat and phone call
            </li>

            <li>
              <span className="check-icon">
                <FaCheck />
              </span>
              Powered by natural, human-like AI conversation
            </li>

            <li>
              <span className="check-icon">
                <FaCheck />
              </span>
              Secure identity verification with OTP
            </li>

            <li>
              <span className="check-icon">
                <FaCheck />
              </span>
              Realistic end-to-end insurance quote flow
            </li>

          </ul>

          {/* Demo Options */}
          <div className="demo-options">

            {/* =========================
                CLOUDCALL CHAT
            ========================= */}
            <div
              id="open-cloudcall"
              className="chat-card"
              onClick={openCloudCallWidget}
              onKeyDown={(event) => {
                if (
                  event.key === "Enter" ||
                  event.key === " "
                ) {
                  event.preventDefault();
                  openCloudCallWidget();
                }
              }}
              role="button"
              tabIndex={0}
              style={{ cursor: "pointer" }}
            >

              <img
                src={logo}
                alt="CloudCall"
                className="demo-image"
              /> 

              <h3>
                Click to Chat
              </h3>

              <p className="card-caption">
                Start an instant conversation
              </p>

            </div>

            {/* =========================
                PHONE CALL
            ========================= */}
            <div className="call-card">

              <FaPhoneAlt className="phone-icon" />

              <h3>
                +267 3165 402
              </h3>

              <p className="card-caption">
                Call to Chat
              </p>

            </div>

          </div>

        </div>
      </div>
    </section>
  );
}